import { makeVar, useReactiveVar } from '@apollo/client'
import { isSamsungBrowser } from 'react-device-detect'

import { CheckinArrowIcon } from '@local/assets/icons'

import Clickable from '@web/components/Clickable'
import useScrollDirection, { ScrollDirection } from '@web/components/TopButton/useScrollDirection'
import { useGlobalStaticStateContext } from '@web/hooks/useGlobalStaticState'
import useMoveNaverAppTopButton, { DISABLE_BOTTON_MARGIN } from '@web/hooks/useMoveNaverAppTopButton'

import styles from './TopButton.module.scss'

type BottomMargin = number | null

const bottomMarginVar = makeVar<BottomMargin>(null)

export const setTopButtonBottomMargin = (bottomMargin: BottomMargin) => bottomMarginVar(bottomMargin)

type ScrollState = {
  scrollDirection: ScrollDirection
  isTop: boolean
}
type Props = {
  rootElement?: Element | null
  externalState?: ScrollState
  hideDirection?: ScrollDirection
  clickCode?: string
}

const TopButton = (props: Props) => {
  const { rootElement, externalState, hideDirection = 'down', clickCode } = props
  const bottomMargin = useReactiveVar(bottomMarginVar)

  const { isSsr } = useGlobalStaticStateContext()

  const state = useScrollDirection({
    skip: !!externalState,
  })

  const scrollDirection = externalState?.scrollDirection ?? state.scrollDirection
  const isTop = externalState?.isTop ?? state.isTop

  useMoveNaverAppTopButton(DISABLE_BOTTON_MARGIN)

  if (isTop) return null

  if (scrollDirection === hideDirection) return null

  if (!isSsr && isSamsungBrowser) return null

  const scrollToTop = () => {
    if (rootElement) {
      rootElement.scrollTo({ top: 0, behavior: 'smooth' })
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }
  }

  const style = bottomMargin ? { bottom: bottomMargin } : {}

  return (
    <div className={styles.bottom_fixed_btn_area} style={style}>
      <Clickable className={styles.btn} onClick={scrollToTop} nClickCode={clickCode}>
        <CheckinArrowIcon className={styles.icon} />
        <span className="place_blind">맨위로</span>
      </Clickable>
    </div>
  )
}

export default TopButton
